import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Account.css'; // Add CSS for centering

const Account = () => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const token = localStorage.getItem('token'); // Assuming JWT is stored in localStorage
    const API_URL = process.env.REACT_APP_API_URL;

    // Fetch existing account details when the Account tab is accessed
    useEffect(() => {
        const fetchAccountDetails = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/account`, {
                    headers: {
                        Authorization: `Bearer ${token}` // Include JWT in headers
                    }
                });
                setUsername(response.data.username);
                setEmail(response.data.email);
            } catch (error) {
                console.error('Error fetching account details:', error);
            }
        };

        fetchAccountDetails();
    }, [token, API_URL]);

    const handleUpdateAccount = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token'); // Get the token
    
            // Create the payload object with username and email
            const payload = {
                username,
                email
            };
    
            // Only include the password if it's not empty
            if (password) {
                payload.password = password;
            }
    
            await axios.put(`${API_URL}/api/account`, payload, {
                headers: {
                    Authorization: `Bearer ${token}` // Include JWT in headers
                }
            });
    
            alert('Account updated successfully!');
        } catch (error) {
            console.error('Error updating account:', error);
            alert('Error updating account');
        }
    };
    

    const handleDeleteAccount = async () => {
        try {
            if (window.confirm('Are you sure you want to delete your account? This action cannot be undone.')) {
                await axios.delete(`${API_URL}/api/account`, {
                    headers: {
                        Authorization: `Bearer ${token}` // Include JWT in headers
                    }
                });
                alert('Account and all associated data deleted successfully!');
                navigate('/'); // Redirect to homepage after deletion
            }
        } catch (error) {
            console.error('Error deleting account:', error);
            alert('Error deleting account');
        }
    };

    return (
        <div className="account-settings">
            <h2>Account Settings</h2>
            <form onSubmit={handleUpdateAccount}>
                <div className="form-group">
                    <label>Username:</label>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Password (leave blank to keep current):</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <button type="submit" className="update-btn">Update Account</button>
            </form>
            <button onClick={handleDeleteAccount} className="delete-account-btn">
                Delete Account
            </button>
        </div>
    );
};

export default Account;
